import Text from '../base/Text';

export default function ProBadge({ className }: { className?: string }) {
  return (
    <Text
      as="div"
      variant="studio/body/sm"
      className={`inline-block rounded-md bg-[#70EB4740] px-2 py-1 font-thin ${
        typeof className === 'string' ? className : ''
      }`}
    >
      Pro
    </Text>
  );
}
